import React, { Component } from 'react';
import moment from 'moment';
import ModalHeader from 'components/base/secure/modals/modal-header';
import MoneyField from 'components/form/money-field';
import DateField from 'components/form/date-field';
import InputField from 'components/form/input-field';
import SaveButton from 'components/form/save-button';
import CategoryPicker from 'components/pickers/category-picker';
import PropTypes from 'prop-types';
import ModalContent from 'components/base/secure/modals/modal-content';
import { withNamespaces } from 'react-i18next';
import { inject } from 'mobx-react';

@withNamespaces()
@inject('store')
class AddTransactionModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            category: props.category,
            amount: '',
            date: moment().month(props.store.budget.month - 1).year(props.store.budget.year).toDate(),
            description: '',
        };

        this.dismiss = this.dismiss.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    onSubmit(e) {
        e.preventDefault();

        if (!this.state.loading) {
            this.setState({loading: true});

            this.props.store.budget.requestAddTransaction(this.state)
                .then(() => this.props.onSuccess())
                .catch(err => this.setState({loading: false}));
        }
    }

    dismiss() {
        if (!this.state.loading) {
            this.props.onDismiss();
        }
    }

    handleChange(e) {
        const { name, value } = e.target;

        this.setState({
            [name]: value,
        });
    }

    render() {
        const { t } = this.props;
        const { loading, category, amount, date, description } = this.state;

        return (
            <ModalContent closeOutside={this.closeOutside}>
                <ModalHeader
                    title={t('BUDGET.TRANSACTION.ADD_TITLE')}
                    close={this.dismiss}
                />
                <div className="modal-body">
                    <form onSubmit={this.onSubmit}>
                        <div style={{marginBottom: '20px'}}>
                            <CategoryPicker
                                name="category"
                                label="Category"
                                onChange={this.handleChange}
                                value={category}
                                required={true}
                            />
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <MoneyField
                                    name="amount"
                                    label="Amount"
                                    onChange={this.handleChange}
                                    value={amount}
                                    required={true}
                                    focusOnRender={true}
                                />
                            </div>
                            <div className="col-md-6">
                                <DateField
                                    name="date"
                                    label="Date"
                                    onChange={this.handleChange}
                                    value={date}
                                    required={true}
                                    restrictToMonth={true}
                                />
                            </div>
                        </div>

                        <InputField
                            name="description"
                            label="Description"
                            onChange={this.handleChange}
                            value={description}
                        />

                        <div className="modal-footer">
                            <SaveButton loading={loading} />
                            <button type="button"
                                    className="btn btn-link"
                                    onClick={this.dismiss}
                                    disabled={loading}
                            >
                                {t('COMMON.OR_CANCEL')}
                            </button>
                        </div>
                    </form>
                </div>
            </ModalContent>
        );
    }
}

AddTransactionModal.propTypes = {
    /** A function that will be called when the modal will be successfully submitted */
    onSuccess: PropTypes.func.isRequired,

    /** A function that will be called when the modal is dismissed (like when user clicks outside) */
    onDismiss: PropTypes.func.isRequired,

    /** Pass Category if adding transaction from Category list */
    category: PropTypes.any,
};

AddTransactionModal.defaultProps = {
    category: '',
};

export default AddTransactionModal;


// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-modals/add-transaction-modal.js